export default "__VITE_ASSET__BcddOD1e__"